<div id="selection-view" class="page-layout blank"  [ngClass]="selectionDetailPanelVisibility ? 'details-visible' : ''" >

  <div class="content">

    <div class="left">

      <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">

        <div class="widget panel-izquierdo-alto" fxFlex="100" fxFlex.gt-sm="{{selectionListPanelSize}}">

          <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
            <div class="widget selction-list-panel" fxFlex="100" fxFlex.gt-sm="100">
              <app-main-filters></app-main-filters>
            </div>
          </div>
          <app-selection-list class="flex-expandir"></app-selection-list>
        </div>

        <div class="widget" fxFlex="100" fxFlex.gt-sm="{{panelSize}}">
          <div class="selection-right-detail-panel">
            <app-leave-panel *ngIf="selectionService.isShowLeavePanel"></app-leave-panel>
            <app-recordings-panel
              *ngIf="selectionService.isRecordingsVisible && sharedService.selectedSelectionTabId === 3">
            </app-recordings-panel>
          </div>
        </div>
 
      </div>

    </div>

  </div>

</div>